import { render, staticRenderFns } from "./SelectProductGroups.vue?vue&type=template&id=c09932f2&scoped=true&"
import script from "./SelectProductGroups.vue?vue&type=script&lang=js&"
export * from "./SelectProductGroups.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=c09932f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09932f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c09932f2')) {
      api.createRecord('c09932f2', component.options)
    } else {
      api.reload('c09932f2', component.options)
    }
    module.hot.accept("./SelectProductGroups.vue?vue&type=template&id=c09932f2&scoped=true&", function () {
      api.rerender('c09932f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SelectProductGroups.vue"
export default component.exports